// extracted by mini-css-extract-plugin
module.exports = {"a-base-layout":"BaseLayout_a-base-layout__2fWaI"};